// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1_zDM","cls2":"AccountMenu-cls2_FyF AccountMenu-cls1_zDM"};